import { useMutation } from '@apollo/client';
import { Grid } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ADD_USER, GET_USERS } from '../gql/users';
import UserForm from './UserForm';
import Note from './layout/Note';
import PageContainer from './layout/PageContainer';
import PagePaper from './layout/PagePaper';

const UserAdd = () => {
  const history = useHistory();
  const [addUser, { error }] = useMutation(ADD_USER, {
    refetchQueries: [{ query: GET_USERS }],
    onCompleted() {
      history.push('/users');
    },
  });

  const formik = useFormik({
    initialValues: {
      netId: '',
      role: 'Admin',
      active: true,
    },
    validationSchema: Yup.object({
      netId: Yup.string().trim().required('Please enter NetID'),
    }),
    onSubmit: (input) => {
      // eslint-disable-next-line no-param-reassign
      input.disabled = !input.active;
      // eslint-disable-next-line no-param-reassign
      input.active = undefined;
      addUser({ variables: { input } });
    },
  });

  return (
    <PageContainer title="Add User">
      <Note>Input info to add user</Note>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PagePaper>
            <UserForm formik={formik} error={error} />
          </PagePaper>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default UserAdd;
